// Tiered step brackets used for money adjustments and tunings. The values
// snap to the nearest multiple of the applicable grid so no "in-between"
// amounts appear in the UI.
//
// The brackets exist because one grid cannot serve the whole range: $1,000 is
// 83% of a $1,200 subscription and 0.01% of a $10M portfolio. Each bracket keeps
// one tap under roughly a tenth of the value on screen.
export const MONEY_STEP_XXS = 100 // $0 – $4,999
export const MONEY_STEP_XS = 500 // $5,000 – $19,999
export const MONEY_STEP_SM = 1_000 // $20,000 – $199,999
export const MONEY_STEP_MD = 2_000 // $200,000 – $499,999
export const MONEY_STEP_LG = 5_000 // $500,000 – $999,999
export const MONEY_STEP_XL = 10_000 // $1,000,000+

export const getMoneyStep = (value: number): number => {
  if (value >= 1_000_000) return MONEY_STEP_XL
  if (value >= 500_000) return MONEY_STEP_LG
  if (value >= 200_000) return MONEY_STEP_MD
  if (value >= 20_000) return MONEY_STEP_SM
  if (value >= 5_000) return MONEY_STEP_XS
  return MONEY_STEP_XXS
}
